import styled, { createGlobalStyle, css } from 'styled-components/macro'
import { Thread } from 'styles/misc'

import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Theme = createGlobalStyle`
:root {
  --theme-color: ${theme.colors.accent.tatari()} !important;
  --links-color: ${theme.colors.accent.tatari(0.55)} !important;
  --music-link-color: ${theme.colors.accent.tatari(0.8)} !important;
}
`

export const Title = styled.h2`
  position: relative;
  width: max-content;
  max-width: 100%;
  text-align: initial;

  &[data-thread]::before {
    ${Thread}
  }
`

export const SmallGraphics = styled.figure<{
  $largeSpacing?: boolean
  $centered?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 5rem auto;
  max-width: 100%;
  text-align: center;

  ${mq.medium} {
    flex-direction: row-reverse;
    width: max-content;
    text-align: inherit;
    margin-left: 0;
  }

  ${props =>
    props.$centered &&
    css`
      ${mq.medium} {
        margin-left: auto;
      }
    `}

  ${props =>
    props.$largeSpacing &&
    css`
      padding-top: var(--header-height);
      margin: 0 auto 5rem;

      ${mq.medium} {
        margin: 0 auto 22rem;
      }
    `}
`

export const GraphicsDescription = styled.figcaption`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;

  span {
    content: '';
    display: block;
    width: 1.6em;
    height: 1.6em;
    margin: 1rem;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: #96cbc4;
  }

  ${mq.medium} {
    max-width: 27rem;
    flex-direction: row;
    gap: 3rem;
    font-size: 1.4rem;
  }

  ${mq.large} {
    margin-left: -5rem;
  }
`

export const GraphicsImage = styled.img`
  display: block;
  max-width: 29rem;

  ${mq.medium} {
    max-width: 42.5rem;
    margin-right: -10rem;
  }
`
